var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{class:_vm.colClass,attrs:{"cols":_vm.cols}},[_c('v-slider',{attrs:{"type":"range","dense":"","min":_vm.min,"max":_vm.max,"step":_vm.step,"prepend-icon":_vm.prependIcon},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }